type GtagFn = (...args: unknown[]) => void

export function fireConversion() {
  (window as Window & { gtag?: GtagFn }).gtag?.(
    'event', 'conversion', { send_to: 'AW-18172244727/4MRZCOLpo7ccEPflmdlD' }
  )
}
